import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      players: {
        bonuses: {
          edit_bonus: {
            back: 'BACK',
            save: 'SAVE',
            header: 'HEADER',
            form: {
              aasm_state: 'AASM_STATE',
              cid: 'CID',
              date: 'DATE',
              bonus_amount: 'BONUS',
            },
          },
        },
      },
    },
  }));
}
